import {
    commonApps,
    employmentBillboard,
    globalConfigurations,
    archive,
} from './productList.service';



/** @typedef {import('./productList.service').AppName} AppName */
/** @typedef {import('./productList.service').Product} Product */
/** @typedef {import('./productList.service').ProductName} ProductName */
/** @typedef {import('./productList.service').CustomProduct<{}>} CustomProduct */


/** @type {CustomProduct[]} */
export const productList = [
    employmentBillboard,
    archive,
    globalConfigurations,
];

/**
 * @param {AppName} appName
 * @returns {Product}
 */
export const getApp = (appName) => commonApps.filter((app) => app.name === appName)[0] || undefined;

/** @param {ProductName} productName */
export const getProduct = (productName) => productList.filter((p) => p.name === productName)[0] || undefined;

export default productList;


